export const LOCALE_PREFIX =
    'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.RegistrationInformation'

export const TABS_PRIORITY = ['identification', 'vatGroup', 'otherInformation']

export const GROUP_VAT_TABLE_KEY = 'STB0A008'
